import React from 'react';
import PropTypes from 'prop-types';
import NavBar from '../NavBar';

PageNormal.propTypes = {
  id: PropTypes.string,
  defaultNavBar: PropTypes.bool,
  defaultNavBarProps: PropTypes.shape({ ...NavBar.propTypes }),
  navBar: PropTypes.node,
  children: PropTypes.node.isRequired
};

PageNormal.defaultProps = {
  id: '',
  defaultNavBar: true,
  defaultNavBarProps: {},
  navBar: null
};

/**
 * 页面组件。正常文档流
 */
export default function PageNormal(props) {
  const {
    id, children,
    navBar, defaultNavBar, defaultNavBarProps
  } = props;

  let targetNavBar = navBar;

  if (!targetNavBar && defaultNavBar) {
    targetNavBar = (<NavBar {...defaultNavBarProps} />);
  }

  return (
    <main id={id} className="component-page component-page-normal">
      {targetNavBar}
      {children}
    </main>
  );
}
